import React, { useState, useEffect } from 'react';
import AdminTemplate from 'components/templates/AdminTemplate';
import { Grid, Typography } from '@material-ui/core';
import ModalContainer from 'components/molecules/ModalContainer';
import useCategoriesIM from 'hooks/useCategoriesIM';
import IMCategoriesList from 'components/organisms/IMCategoriesList';
import IMCategoryForm from 'components/organisms/IMCategoryForm';
import IMCategoryDeleteModal from 'components/organisms/IMCategoryDeleteModal';
import { ICategories, ICategoriesList } from 'interfaces/imCategories.interface';

export default function IMCategories() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [categoryId, setCategoryId] = useState('');
  const [categories, setCategories] = useState<ICategories[]>([]);
  const { getCategories, addCategory, updateCategory } = useCategoriesIM();

  const handleOnCloseModal = () => {
    setOpenModalEdit(false);
  };

  const getAllCategories = () => {
    setIsLoading(true);
    getCategories()
      .then((result: ICategoriesList) => {
        if (result) {
          setCategories(result.categories);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const saveCategory = (data: ICategories) => {
    if (data.id) {
      return updateCategory(data);
    } else {
      return addCategory(data);
    }
  };

  const handleOnClickEditCategory = (categoryId: string) => {
    setCategoryId(categoryId);
    setOpenModalEdit(true);
  };

  const handleOnClickDeleteCategory = (categoryId: string) => {
    setCategoryId(categoryId);
    setOpenDeleteModal(true);
  };

  const addCategoryButton = () => {
    setCategoryId('');
    setOpenModalEdit(true);
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  return (
    <AdminTemplate>
      <Grid container justify="center" spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography variant="h5" component="h1" align="center">
            Gestión de Categorías
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={8}>
          <IMCategoriesList
            handleOnClickEditCategory={handleOnClickEditCategory}
            handleOnClickDeleteCategory={handleOnClickDeleteCategory}
            addCategoryButton={addCategoryButton}
            IMCategories={categories}
            isLoading={isLoading}
          />
        </Grid>
        <ModalContainer title="Crear categoría" open={openModalEdit} onClose={handleOnCloseModal}>
          <IMCategoryForm
            handleCloseModal={handleOnCloseModal}
            handleOnSubmit={saveCategory}
            isPromotion={false}
            categoryId={categoryId}
            getAllCategories={getAllCategories}
          />
        </ModalContainer>

        <IMCategoryDeleteModal
          onClose={() => {
            setOpenDeleteModal(!openDeleteModal);
          }}
          open={openDeleteModal}
          categoryId={categoryId}
          getAllCategories={getAllCategories}
        />
      </Grid>
    </AdminTemplate>
  );
}
